<template>
  <div ref="resultsRef">
    <div class="jumbotron">
      <ol class="breadcrumb">
        <li class="breadcrumb-item"><a href="#/home">Home</a></li>
          <li class="breadcrumb-item"><a href="#/apps">Apps</a></li>
          <li class="breadcrumb-item active">Log for {{ app.name }} ({{app.id}})</li>
      </ol>
    </div>
    <text-editor
      v-if="showEditor"
      v-bind:contentProp="textBlock"
      v-bind:width="textBlockWidth"
      v-bind:height="textBlockHeight"
      v-bind:readonly="textBlockReadOnly"
      v-bind:scrollToLine="scrollToLine"
      v-bind:lang="textBlockLang">
    </text-editor>
    <p>Number of log records: {{ numLogs }}</p>
    <div class="btn-group" role="group">
      <button type="button" class="btn"
        :class="{ 'btn-primary': !disableStart }"
        :disabled="disableStart"
        v-on:click="openWs">
        <i class="fa fa-play" aria-hidden="true"></i>
      </button>
      <button type="button" class="btn" 
        :class="{ 'btn-primary': !disableStop }"
        :disabled="disableStop"
        v-on:click="closeWs">
        <i class="fa fa-stop" aria-hidden="true"></i>
      </button>
      <button type="button" class="btn"
        v-on:click="clearLogs">
        <i class="fa fa-bomb" aria-hidden="true"></i>
      </button>
    </div>
    <feedback id="feedback" v-bind:message="message" v-bind:spin="showSpinner" v-bind:success="success"></feedback>
  </div>
</template>
<script>
  import Feedback from '@/components/Feedback.vue'
  import TextEditor from '@/components/TextEditor.vue'
  export default {
    components: {
      Feedback,
      TextEditor
    },
    data: function () {
      return {
        app: Object,
        logs: [],
        message: '',
        success: false,
        wsOpen: false,
        showSpinner: false,
        showEditor: false,
        textBlockWidth: 0,
        textBlockHeight: 0,
        textBlockReadOnly: true,
        scrollToLine: true,
        disableStop: false,
        disableStart: true,
        textBlockLang: 'sql'
      }
    },
    methods: {
      openWs: function () {
        let vm = this
        // let wsUrl = 'ws://localhost:7705/' + vm.app.id
        let wsUrl = 'wss://portal.heliumapps.com/portal-backend/ws/' + vm.app.id
        vm.message = 'Opening websocket connection to ' + wsUrl
        vm.showSpinner = true
        vm.$parent.socket = new WebSocket(wsUrl)
        vm.$parent.socket.onopen = function () {
          vm.resizeEditor()

          let credentials = {}
          credentials['userName'] = vm.$parent.username
          credentials['password'] = vm.$parent.password
          let data = {}
          data['baseUrl'] = vm.$parent.environment.baseUrl
          data['credentials'] = credentials

          vm.$parent.socket.send(JSON.stringify(data))

          vm.$parent.socket.onmessage = function (response) {
            vm.success = true
            vm.wsOpen = true
            var json = JSON.parse(response.data)
            var log = (new Date(json.millis)).toLocaleString() + ' - ' + json.key + ' - ' + json.value
            vm.logs.push(log)
            vm.message = 'Streaming Logs...'
            vm.showSpinner = true
            vm.disableStop = false
            vm.disableStart = true
          }
        }
        vm.$parent.socket.onclose = function (response) {
          var log = (new Date()).toLocaleString() + ' - Terminate - Connection to portal backend closed.'
          vm.logs.push(log)

          vm.message = 'Socket closed with code ' + response.code + '.'
          vm.showSpinner = false
          vm.success = false
          if (response.code === 1006) {
            vm.message = vm.message + ' ' + 'The connection was closed abnormally, e.g., without sending or receiving a Close control frame (RFC 6455 - The WebSocket Protocol)'
          }
          vm.wsOpen = false
          vm.disableStop = true
          vm.disableStart = false
        }
      },
      closeWs: function () {
        let vm = this
        vm.$parent.closeWs()
        vm.wsOpen = false
        vm.showSpinner = false
      },
      clearLogs: function () {
        this.logs = []
      },
      resizeEditor: function () {
        var newHeight = window.innerHeight
        var newWidth = 0
        if (this.$refs.resultsRef) {
          newWidth = this.$refs.resultsRef.clientWidth
        }
        this.textBlockWidth = Math.round(newWidth * 90 / 100)
        this.textBlockHeight = Math.round(newHeight * 60 / 100)
        this.showEditor = true
      }
    },
    created () {
      let vm = this
      vm.$parent.apps.forEach(function (key) {
        if (key.id === vm.$route.params.appid) {
          vm.app = key
        }
      })
      vm.openWs()
      window.addEventListener('resize', this.resizeEditor)
    },
    beforeDestroy: function () {
      window.removeEventListener('resize', this.resizeEditor)
    },
    computed: {
      numLogs: function () {
        return this.logs.length
      },
      textBlock: function () {
        return this.logs.join('\n')
      }
    }
  }
</script>

<style scoped>
    #feedback {
        margin-top: 10px;
    }
</style>



// WEBPACK FOOTER //
// AppLogs.vue?3d388625